import GlobalConstImport from "../constants/GlobalConst";
const GlobalConst = GlobalConstImport.default ?? GlobalConstImport;

let baseWager = 5.0;
if (GlobalConst.SITE_CURRENCY === "US")
    baseWager = 5.0;
else if (GlobalConst.SITE_CURRENCY === "MXN")
    baseWager = 50.0

class Pick12PayoutCalculator {
    static TotalTrials = 12;
    static BaseWager = baseWager;

    static Probabilities = {
        // k=0
        "0-0": 0.00, "0-1": 0.15, "0-2": 0.18, "0-3": 0.26,
        "0-4": 0.36, "0-5": 0.50, "0-6": 0.66, "0-7": 0.81,
        "0-8": 0.94, "0-9": 1.00, "0-10": 1.00, "0-11": 1.00, "0-12": 1.00,

        // k=1
        "1-0": 0.15, "1-1": 0.11, "1-2": 0.11, "1-3": 0.15,
        "1-4": 0.23, "1-5": 0.34, "1-6": 0.50, "1-7": 0.69,
        "1-8": 0.88, "1-9": 1.00, "1-10": 1.00, "1-11": 1.00, "1-12": 0.00,

        // k=2
        "2-0": 0.18, "2-1": 0.11, "2-2": 0.07, "2-3": 0.07,
        "2-4": 0.11, "2-5": 0.19, "2-6": 0.31, "2-7": 0.50,
        "2-8": 0.75, "2-9": 1.00, "2-10": 1.00, "2-11": 0.00, "2-12": 0.00,

        // k=3
        "3-0": 0.26, "3-1": 0.15, "3-2": 0.07, "3-3": 0.03,
        "3-4": 0.03, "3-5": 0.06, "3-6": 0.13, "3-7": 0.25,
        "3-8": 0.50, "3-9": 1.00, "3-10": 0.00, "3-11": 0.00, "3-12": 0.00,

        // k=4
        "4-0": 0.36, "4-1": 0.23, "4-2": 0.11, "4-3": 0.03,
        "4-4": 0.00, "4-5": 0.00, "4-6": 0.00, "4-7": 0.00,
        "4-8": 0.00, "4-9": 0.00, "4-10": 0.00, "4-11": 0.00, "4-12": 0.00,

        // k=5
        "5-0": 0.50, "5-1": 0.34, "5-2": 0.19, "5-3": 0.06,
        "5-4": 0.00, "5-5": 0.00, "5-6": 0.00, "5-7": 0.00,
        "5-8": 0.00, "5-9": 0.00, "5-10": 0.00, "5-11": 0.00, "5-12": 0.00,

        // k=6
        "6-0": 0.66, "6-1": 0.50, "6-2": 0.31, "6-3": 0.13,
        "6-4": 0.00, "6-5": 0.00, "6-6": 0.00, "6-7": 0.00,
        "6-8": 0.00, "6-9": 0.00, "6-10": 0.00, "6-11": 0.00, "6-12": 0.00,

        // k=7
        "7-0": 0.81, "7-1": 0.69, "7-2": 0.50, "7-3": 0.25,
        "7-4": 0.00, "7-5": 0.00, "7-6": 0.00, "7-7": 0.00,
        "7-8": 0.00, "7-9": 0.00, "7-10": 0.00, "7-11": 0.00, "7-12": 0.00,

        // k=8
        "8-0": 0.94, "8-1": 0.88, "8-2": 0.75, "8-3": 0.50,
        "8-4": 0.00, "8-5": 0.00, "8-6": 0.00, "8-7": 0.00,
        "8-8": 0.00, "8-9": 0.00, "8-10": 0.00, "8-11": 0.00, "8-12": 0.00,

        // k=9
        "9-0": 1.00, "9-1": 1.00, "9-2": 1.00, "9-3": 1.00,
        "9-4": 0.00, "9-5": 0.00, "9-6": 0.00, "9-7": 0.00,
        "9-8": 0.00, "9-9": 0.00, "9-10": 0.00, "9-11": 0.00, "9-12": 0.00,

        // k=10
        "10-0": 1.00, "10-1": 1.00, "10-2": 1.00, "10-3": 0.00,
        "10-4": 0.00, "10-5": 0.00, "10-6": 0.00, "10-7": 0.00,
        "10-8": 0.00, "10-9": 0.00, "10-10": 0.00, "10-11": 0.00, "10-12": 0.00,

        // k=11
        "11-0": 1.00, "11-1": 1.00, "11-2": 0.00, "11-3": 0.00,
        "11-4": 0.00, "11-5": 0.00, "11-6": 0.00, "11-7": 0.00,
        "11-8": 0.00, "11-9": 0.00, "11-10": 0.00, "11-11": 0.00, "11-12": 0.00,

        // k=12
        "12-0": 1.00, "12-1": 0.00, "12-2": 0.00, "12-3": 0.00,
        "12-4": 0.00, "12-5": 0.00, "12-6": 0.00, "12-7": 0.00,
        "12-8": 0.00, "12-9": 0.00, "12-10": 0.00, "12-11": 0.00, "12-12": 0.00,
    };

    static getWinningProbability(k, r) {
        return this.Probabilities[`${k}-${r}`];
    }

    HardcodedPayoutsUSD = [
        500, 50, 10, 5, 0, 0, 0, 0, 0, 5, 10, 100, 2000
    ];
    HardcodedPayoutsMXN = [
        5000, // 0 correct
        500,  // 1 correct
        100,  // 2 correct
        50,   // 3 correct
        0,    // 4 correct
        0,    // 5 correct
        0,    // 6 correct
        0,    // 7 correct
        0,    // 8 correct
        50,   // 9 correct
        100,  // 10 correct
        1000, // 11 correct
        20000 // 12 correct
    ];

    // Method to calculate distribution
    calculateDistribution(wager, rollingPayout = 0.0) {
        const resultTable = [];
        let payouts = [];
        if(GlobalConst.SITE_CURRENCY === "US") payouts = this.HardcodedPayoutsUSD;
        else if(GlobalConst.SITE_CURRENCY === "MXN") payouts = this.HardcodedPayoutsMXN;

        for (let successes = 0; successes <= Pick12PayoutCalculator.TotalTrials; successes++) {
            let adjustedPayout = (payouts[successes] * wager) / Pick12PayoutCalculator.BaseWager;
            if (successes === Pick12PayoutCalculator.TotalTrials) {
                adjustedPayout += rollingPayout;
            }

            resultTable.push({
                correct: successes,
                total: Pick12PayoutCalculator.TotalTrials,
                multiplier:  adjustedPayout/wager,
                payout: adjustedPayout
            });
        }

        return resultTable;
    }
}

export default Pick12PayoutCalculator;
